









import Vue from 'vue';
export default Vue.extend({
  name: 'ModalBase',
  props: {
    modalWidth: {
      default: '100%',
    },
  },
});
